import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/armsform.css';

const EditLocalCert = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [entry, setEntry] = useState({ ...state.entry, token_id: state.entry.token_id });
    const [error, setError] = useState(null);
    const [showPopup, setShowPopup] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEntry((prevEntry) => ({
            ...prevEntry,
            [name]: value,
        }));
    };

    const getDashboardUrl = () => {
        if (state?.userRole === 'admin') {
            return '/admin-dashboard';
        } else if (state?.userRole === 'lcuid') {
            return '/local-certificate-dashboard';
        } else {
            console.error('Invalid user role:', state?.userRole);
            return '/local-certificate-dashboard';
        }
    };

    const handleCancel = () => {
        navigate(getDashboardUrl());
    };

    const handleSave = async () => {
        console.log('Entry data before saving:', JSON.stringify(entry, null, 2));
        try {
            const response = await axios.post('https://chaman.gob.pk/eac_backend/edit-localcert.php', {
                action: 'update',
                ...entry,
            });

            console.log('Server response:', response.data);

            if (response.data?.status === 'success') {
                setShowPopup(true);
                setTimeout(() => setShowPopup(false), 2000);
                setTimeout(() => navigate(getDashboardUrl()), 2000);
            } else {
                const errorMsg = response.data?.message || 'Failed to update entry';
                setError(errorMsg);
                alert(errorMsg);
            }
        } catch (err) {
            console.error('Update error:', err);
            setError('Error updating entry. Please try again later.');
        }
    };

    return (
        <div className="lc-form-container">
            <form className="lc-form">
                <div className="lc-left-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Token ID:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="token_id"
                                value={entry.token_id}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="local_no"
                                value={entry.local_no}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Date:</label>
                        <div className="lc-input-container">
                            <input
                                type="date"
                                name="date"
                                value={entry.date}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Name:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="name"
                                value={entry.name}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                </div>

                <div className="lc-right-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Father Name:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="father_name"
                                value={entry.father_name}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">CNIC:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="cnic"
                                value={entry.cnic}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Phone No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="phone_no"
                                value={entry.phone_no}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Status:</label>
                        <div className="lc-input-container">
                            <select 
                                name="status" 
                                value={entry.status} 
                                onChange={handleChange}
                                className="lc-select"
                                required
                            >
                                <option value="" disabled>Select Status</option>
                                <option value="Recieved">Recieved</option>
                                <option value="Ready">Ready</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="lc-form-buttons">
                <button type="button" className="lc-submit-btn" onClick={handleSave}>
                    Update
                </button>
                <button type="button" className="lc-cancel-btn" onClick={handleCancel}>
                    Cancel
                </button>
            </div>
            </form>
           
            {error && <div className="lc-error-message">{error}</div>}
            {showPopup && (
                <div className="lc-popup">
                    Entry updated successfully!
                </div>
            )}
        </div>
    );
};

export default EditLocalCert;